module.exports = __webpack_public_path__ + "static/media/logo.4b921af1.svg";